import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { loginLink } from '../config';
import { Store } from '../Store';

export default function ProtectedRoute({ children }) {
  const { state } = useContext(Store);
  const { userInfo } = state;
  return userInfo ? children : window.location.replace(loginLink);
}
